"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _title = _interopRequireDefault(require("./title"));
var _labeledSlider = _interopRequireDefault(require("./labeled-slider"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _intlFormatter = require("@godaddy/intl-formatter");
var _react2 = require("@linaria/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Logo = /*#__PURE__*/_react.default.lazy(() => Promise.resolve().then(() => _interopRequireWildcard(require('./logo'))));
const SliderWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SliderWrapper",
  class: "pl-s1tcn81h"
});
const SubtitleWrapper = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "SubtitleWrapper",
  class: "pl-s1ia4ycx"
});
const Sliders = ({
  title,
  ratio = 0,
  sales = 0,
  logoAlt,
  ratioEid,
  salesEid,
  subtitle,
  salesStep,
  ratioStep,
  ratioTitle,
  salesTitle,
  tooltipTitle,
  transactions = 0,
  salesMinValue,
  onSalesChange,
  onRatioChange,
  salesMaxValue,
  ratioMinValue,
  ratioMaxValue,
  tooltipMessage,
  ratioRangeLeft,
  ratioRangeRight,
  transactionsEid,
  transactionsStep,
  transactionsTitle,
  salesTooltipMessage,
  ratioTooltipMessage,
  transactionsMinValue,
  onTransactionsChange,
  transactionsMaxValue,
  transactionsTooltipMessage
}) => {
  const currency = new _intlFormatter.Currency();
  return /*#__PURE__*/_react.default.createElement(SliderWrapper, {
    "data-cy": "savings-calculator-sliders"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Suspense, {
    fallback: logoAlt
  }, /*#__PURE__*/_react.default.createElement(Logo, {
    logoAlt: logoAlt,
    "data-cy": "savings-calculator-logo"
  })), /*#__PURE__*/_react.default.createElement(_title.default, {
    title: title,
    tooltipTitle: tooltipTitle,
    tooltipMessage: tooltipMessage,
    "data-cy": "savings-calculator-title"
  }), /*#__PURE__*/_react.default.createElement(SubtitleWrapper, {
    "data-cy": "savings-calculator-subtitle"
  }, subtitle), /*#__PURE__*/_react.default.createElement(_labeledSlider.default, {
    id: "ux-slider-0",
    value: sales,
    onChange: onSalesChange,
    title: salesTitle,
    tooltipMessage: salesTooltipMessage,
    minValue: salesMinValue,
    maxValue: salesMaxValue,
    step: salesStep,
    rangeIndicatorsContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null, `${currency.formatDecimal(sales, 'en-US', 'USD', {
      excludeDecimal: true
    })}`)),
    dataCy: "savings-calculator-sales-slider",
    eid: salesEid
  }), /*#__PURE__*/_react.default.createElement(_labeledSlider.default, {
    id: "ux-slider-1",
    value: transactions,
    onChange: onTransactionsChange,
    title: transactionsTitle,
    tooltipMessage: transactionsTooltipMessage,
    minValue: transactionsMinValue,
    maxValue: transactionsMaxValue,
    step: transactionsStep,
    rangeIndicatorsContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null, currency.formatDecimal(transactions, 'en-US', 'USD', {
      excludeDecimal: true,
      excludeSymbol: true
    }))),
    dataCy: "savings-calculator-transactions-slider",
    eid: transactionsEid
  }), /*#__PURE__*/_react.default.createElement(_labeledSlider.default, {
    id: "ux-slider-2",
    value: ratio,
    onChange: onRatioChange,
    title: ratioTitle,
    tooltipMessage: ratioTooltipMessage,
    minValue: ratioMinValue,
    maxValue: ratioMaxValue,
    step: ratioStep,
    rangeIndicatorsContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, ratio.toFixed(2), "% ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, ratioRangeLeft)), /*#__PURE__*/_react.default.createElement("div", {
      className: "ralign"
    }, (100 - ratio).toFixed(2), "%", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, ratioRangeRight))),
    dataCy: "savings-calculator-ratio-slider",
    eid: ratioEid
  }));
};
var _default = exports.default = Sliders;
Sliders.propTypes = {
  ratio: _propTypes.default.number,
  sales: _propTypes.default.number,
  title: _propTypes.default.string,
  logoAlt: _propTypes.default.string,
  ratioEid: _propTypes.default.string,
  salesEid: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  salesStep: _propTypes.default.number,
  ratioStep: _propTypes.default.number,
  ratioTitle: _propTypes.default.string,
  salesTitle: _propTypes.default.string,
  tooltipTitle: _propTypes.default.string,
  transactions: _propTypes.default.number,
  onSalesChange: _propTypes.default.func,
  onRatioChange: _propTypes.default.func,
  salesMinValue: _propTypes.default.number,
  salesMaxValue: _propTypes.default.number,
  ratioMinValue: _propTypes.default.number,
  ratioMaxValue: _propTypes.default.number,
  tooltipMessage: _propTypes.default.string,
  ratioRangeLeft: _propTypes.default.node,
  ratioRangeRight: _propTypes.default.node,
  transactionsEid: _propTypes.default.string,
  transactionsStep: _propTypes.default.number,
  transactionsTitle: _propTypes.default.string,
  salesTooltipMessage: _propTypes.default.string,
  ratioTooltipMessage: _propTypes.default.string,
  transactionsMinValue: _propTypes.default.number,
  transactionsMaxValue: _propTypes.default.number,
  onTransactionsChange: _propTypes.default.func,
  transactionsTooltipMessage: _propTypes.default.string
};